export namespace CssPropertiesNames {
  export const borderTopWidth = 'border-top-width';
  export const borderBottomWidth = 'border-bottom-width';
  export const backgroundPositionY = 'background-position-y';
}
